<template>
  <DxTooltip
    ref="tooltipRef"
    :animation="null"
    :hide-on-outside-click="false"
    :max-width="maxWidth"
    :position="position"
    :target="internalTarget"
    :wrapper-attr="wrapperAttr"
    content-template="content-template"
    hide-event="mouseleave"
    show-event="mouseenter"
  >
    <template #content-template>
      <div :class="{ 'multiline-tooltip': multiline }">
        <template v-if="isTranslationKey(internalText)">
          <i18n-t :keypath="internalText">
            <template #lineEnding>
              <br />
            </template>
          </i18n-t>
        </template>
        <template v-else>
          <span v-html="formatText(internalText)"></span>
        </template>
      </div>
    </template>
  </DxTooltip>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { DxTooltip } from "devextreme-vue/tooltip";
import { useI18n } from "vue-i18n";

const { te } = useI18n();

const props = withDefaults(
  defineProps<{
    target: string;
    text: string;
    position?: string;
    wrapperAttr?: Record<string, unknown>;
    multiline?: boolean;
    maxWidth?: any;
    showOnlyWhenOverflowed?: boolean;
  }>(),
  {
    position: "right",
    wrapperAttr: () => ({ class: "hint" }),
    multiline: false,
    maxWidth: null,
    showOnlyWhenOverflowed: false,
  },
);

const internalText = ref("");
const internalTarget = ref<any>(null);
const tooltipRef = ref<any>();

function isTranslationKey(text: string): boolean {
  return te(text);
}

function formatText(text: string): string {
  return text.replace(/\{lineEnding\}/g, "<br>");
}

function isEllipsisActive(el: HTMLElement): boolean {
  return el.offsetWidth < el.scrollWidth;
}

function show(target: HTMLElement, text?: string): void {
  internalText.value = text ?? "";
  internalTarget.value = target;
  if (!internalText.value) {
    return;
  }
  if (props.showOnlyWhenOverflowed) {
    if (isEllipsisActive(internalTarget.value)) {
      tooltipRef.value.instance.show();
    }
  } else {
    tooltipRef.value.instance.show();
  }
}

function hide(): void {
  internalTarget.value = null;
  internalText.value = "";
  tooltipRef.value.instance.hide();
}

onMounted(() => {
  internalText.value = props.text;
  internalTarget.value = props.target;
});

defineExpose({ show, hide, isEllipsisActive });
</script>
